/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All the possible legend alignment types.
 */
export type ChartLegendAlignmentType = ChartLegendAlignmentTypeBottom | ChartLegendAlignmentTypeRight;

/**
 * The legend bottom alignment type.
 */
export type ChartLegendAlignmentTypeBottom = typeof CHART_LEGEND_ALIGNMENT_TYPE_BOTTOM;

/**
 * The legend right alignment type.
 */
export type ChartLegendAlignmentTypeRight = typeof CHART_LEGEND_ALIGNMENT_TYPE_RIGHT;

/**
 * The legend bottom alignment constant.
 */
export const CHART_LEGEND_ALIGNMENT_TYPE_BOTTOM = 'bottom';

/**
 * The legend right alignment constant.
 */
export const CHART_LEGEND_ALIGNMENT_TYPE_RIGHT = 'right';
